import React, { Component } from 'react';
import { parseXMLtoJS } from '../common/parseXMLtoJS';
import { getXmlFile } from '../common/xmlretriever';
import { DictionaryConfigDM, DictionaryWordDM } from '../datamodel/datamodel';
import parse from 'html-react-parser';

import '../css/dictionary.css';

class IteamDictionaryComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {selectedUnit: 0,
                      displayedWords: [],
                      selectedItemDM: null,
                      inputBGColorStyle: {}
                     };

        this.notFoundInputBGColor = '#F69220';
        this.dictionaryConfigDM = null;
        this.filteredWords = [];
        this.contentsXMLIsRetrievedCallBack = this.contentsXMLIsRetrievedCallBack.bind(this);
        this.parseDictionaryModel = this.parseDictionaryModel.bind(this);
        this.itemClickHandler = this.itemClickHandler.bind(this);
        this.playAudioCallBack = this.playAudioCallBack.bind(this);
        this.searchInputOnKeyUpCallBack = this.searchInputOnKeyUpCallBack.bind(this);
        this.clearSearchInputButtonOnClickCallBack = this.clearSearchInputButtonOnClickCallBack.bind(this);
        this.unitSelectBoxOnChangeCallBack = this.unitSelectBoxOnChangeCallBack.bind(this);

        this.inputBoxRef = React.createRef();
    }


    componentDidMount() {
        getXmlFile(this.props.sectionItem.basePath + '/' + this.props.sectionItem.configxml, this.contentsXMLIsRetrievedCallBack, null);

        this.props.setHeaderTitleInfoCallback({sectiontitle: 'DICTIONARY', chaptertitle: '', pagenumbers: '', type: 'dictionary'});
    }


    contentsXMLIsRetrievedCallBack(response) {
        let dictionaryJSModel = parseXMLtoJS(response.data);
        let dictionaryConfigDM = this.parseDictionaryModel(dictionaryJSModel);
        this.dictionaryConfigDM = dictionaryConfigDM;
        this.filteredWords = dictionaryConfigDM.words;
        this.setState({displayedWords: this.filteredWords});
        if (this.filteredWords.length > 0) {
            let dictionaryWordDM = this.filteredWords[0];
            this.setState({selectedItemDM: dictionaryWordDM});
        }
    }

    parseDictionaryModel(dictionaryJSModel) {
        let dictionaryConfigDM = new DictionaryConfigDM();
        if (dictionaryJSModel.dictionary === undefined) {
            return null;
        }

        if (dictionaryJSModel.dictionary.config === undefined) {
            return null;
        }

        let config = dictionaryJSModel.dictionary.config;

        let dictionaryXmlFullPath = `${this.props.sectionItem.basePath}/${this.props.sectionItem.configxml}`;
        let pathParts = dictionaryXmlFullPath.split('/');
        pathParts.splice(pathParts.length - 1, 1);
        let basePath = pathParts.join('/');

        dictionaryConfigDM.basePath = basePath;

        if (config.showEnglishMeaning !== undefined && config.showEnglishMeaning._text !== undefined && config.showEnglishMeaning._text === 'true') {
            dictionaryConfigDM.showEnglisMeaning = true;
        } else {
            dictionaryConfigDM.showEnglisMeaning = false;
        }
        
        if (config.showTurkishMeaning !== undefined && config.showTurkishMeaning._text !== undefined && config.showTurkishMeaning._text === 'true') {
            dictionaryConfigDM.showTurkishMeaning = true;
        } else {
            dictionaryConfigDM.showTurkishMeaning = false;
        }

        if (config.showType !== undefined && config.showType._text !== undefined && config.showType._text === 'true') {
            dictionaryConfigDM.showType = true;
        } else {
            dictionaryConfigDM.showType = false;
        }

        if (config.showSynonym !== undefined && config.showSynonym._text !== undefined && config.showSynonym._text === 'true') {
            dictionaryConfigDM.showSynonym = true;
        } else {
            dictionaryConfigDM.showSynonym = false;
        }

        if (config.showAntonym !== undefined && config.showAntonym._text !== undefined && config.showAntonym._text === 'true') {
            dictionaryConfigDM.showAntonym = true;
        } else {
            dictionaryConfigDM.showAntonym = false;
        }

        if (config.showExamples !== undefined && config.showExamples._text !== undefined && config.showExamples._text === 'true') {
            dictionaryConfigDM.showExamples = true;
        } else {
            dictionaryConfigDM.showExamples = false;
        }

        if (config.classPrefix !== undefined && config.classPrefix._text !== undefined) {
            dictionaryConfigDM.classPrefix = config.classPrefix._text;
        }


        if (config.units !== undefined) {
            if (config.units.unit !== undefined && !Array.isArray(config.units.unit)) {
                // if it has a single item, conver it to array
                let tmp = config.units.unit;
                config.units.unit = [];
                config.units.unit.push(tmp);
            }

            if (config.units.unit.length > 0) {
                dictionaryConfigDM.units = []; // reset default hard coded model
            }

            let units = config.units.unit;
            units.forEach(unit => {
                if (unit._attributes.value === undefined || unit._text === undefined) {
                    return;
                }

                let unitObject = {
                    unit_value: unit._attributes.value, 
                    unit_name: unit._text
                };

                dictionaryConfigDM.units.push(unitObject);

            });
        }






        if (dictionaryJSModel.dictionary.words === undefined) {
            return dictionaryConfigDM;
        }

        if (dictionaryJSModel.dictionary.words.word === undefined) {
            return dictionaryConfigDM;
        }

        let wordsJS = dictionaryJSModel.dictionary.words.word;
        if (!Array.isArray(wordsJS)) {
            let tmp = wordsJS;
            wordsJS = [];
            wordsJS.push(tmp);
        }

        wordsJS.forEach(wordJS => {
            let dictionaryWordDM = new DictionaryWordDM();
            if (wordJS.text !== undefined && wordJS.text._text !== undefined) {
                dictionaryWordDM.text = wordJS.text._text;
            } else {
                dictionaryWordDM.text = null;
            }

            if (wordJS.synonym !== undefined && wordJS.synonym._text !== undefined) {
                dictionaryWordDM.synonym = wordJS.synonym._text;
            } else {
                dictionaryWordDM.synonym = null;
            }

            if (wordJS.antonym !== undefined && wordJS.antonym._text !== undefined) {
                dictionaryWordDM.antonym = wordJS.antonym._text;
            } else {
                dictionaryWordDM.antonym = null;
            }

            if (wordJS.meaning_tr !== undefined && wordJS.meaning_tr._text !== undefined) {
                dictionaryWordDM.meaningTR = wordJS.meaning_tr._text;
            } else {
                dictionaryWordDM.meaningTR = null;
            }

            if (wordJS.meaning_en !== undefined && wordJS.meaning_en._text !== undefined) {
                dictionaryWordDM.meaningEN = wordJS.meaning_en._text;
            } else {
                dictionaryWordDM.meaningEN = null;
            }

            if (wordJS.type !== undefined && wordJS.type._text !== undefined) {
                dictionaryWordDM.type = wordJS.type._text;
            } else {
                dictionaryWordDM.type = null;
            }

            if (wordJS.labels !== undefined && wordJS.labels._text !== undefined) {
                dictionaryWordDM.labels = wordJS.labels._text;
            } else {
                dictionaryWordDM.labels = null;
            }


            if (wordJS.sentence !== undefined && wordJS.sentence._text !== undefined) {
                let sentence = wordJS.sentence._text.replaceAll('i>', 'strong>');
                let sentences = sentence.split('\n');
                dictionaryWordDM.sentences = sentences;
            } else {
                dictionaryWordDM.sentences = [];
            }

            if (wordJS.image !== undefined && wordJS.image._text !== undefined) {
                dictionaryWordDM.imageUrl = wordJS.image._text;
            } else {
                dictionaryWordDM.imageUrl = null;
            }

            if (wordJS.audio !== undefined && wordJS.audio._text !== undefined) {
                dictionaryWordDM.audioUrl = wordJS.audio._text;
            } else {
                dictionaryWordDM.audioUrl = null;
            }

            dictionaryConfigDM.words.push(dictionaryWordDM);

        });

        return dictionaryConfigDM;
    }

    itemClickHandler(dictionaryWordDM) {
        this.setState({selectedItemDM: dictionaryWordDM});
    }

    playAudioCallBack(dictionaryWordDM) {
        if (dictionaryWordDM === null) {
            return;
        }

        if (dictionaryWordDM.audioUrl === null) {
            return;
        }

        let url = `${this.dictionaryConfigDM.basePath}/${dictionaryWordDM.audioUrl}`;
        new Audio(url).play();
    }

    searchInputOnKeyUpCallBack(event) {
        let inputBox = event.target;
        this.searchInputContentChanged(inputBox);
    }

    searchInputContentChanged(inputBox) {
        if (this.filteredWords === null || this.filteredWords.length === 0) {
            return;
        }

        let newList = [];
        let value = inputBox.value.toLowerCase();
        let words = this.filteredWords;
        words.forEach(dictionaryWordDM => {
            if (dictionaryWordDM.text.toLowerCase().startsWith(value)) {
                newList.push(dictionaryWordDM);
            }
        });
        this.setState({displayedWords: newList});

        if (newList.length > 0) {
            let dictionaryWordDM = newList[0];
            this.setState({selectedItemDM: dictionaryWordDM});
            this.setState({inputBGColorStyle: {}});
        } else {
            this.setState({inputBGColorStyle: {backgroundColor: this.notFoundInputBGColor}});
        }
    }

    clearSearchInputButtonOnClickCallBack(event) {
        this.inputBoxRef.current.value = '';
        this.searchInputContentChanged(this.inputBoxRef.current);
    }

    unitSelectBoxOnChangeCallBack(event) {
        let selectedUnit = event.target.value;
        if (this.dictionaryConfigDM === null) {
            return;
        }

        let searchLabel = this.dictionaryConfigDM.classPrefix + selectedUnit;
        let filteredWords = [];
        this.dictionaryConfigDM.words.forEach(dictionaryWordDM => {
            if (dictionaryWordDM.labels.includes(searchLabel)) {
                filteredWords.push(dictionaryWordDM);
            }
        });
        this.filteredWords = filteredWords;
        this.inputBoxRef.current.value = '';
        this.searchInputContentChanged(this.inputBoxRef.current);
    }

    render() {
        let words = [];
        let dictionaryWordDM = new DictionaryWordDM();
        dictionaryWordDM.text = 'Not found...';
        words.push(dictionaryWordDM);

        if (this.state.displayedWords !== null && this.state.displayedWords.length > 0) {
            words = this.state.displayedWords;
        }

        let type = '';
        if (this.dictionaryConfigDM !== null && this.state.selectedItemDM !== null && this.state.selectedItemDM.type !== null) {
            type = (<span className='IteamDictionaryWordType'>({this.state.selectedItemDM.type})</span>);
        }

        let synonym = '';
        if (this.dictionaryConfigDM !== null && this.dictionaryConfigDM.showSynonym && this.state.selectedItemDM !== null && this.state.selectedItemDM.synonym !== null) {
            synonym = (<div className='Synonym'>synonym: {this.state.selectedItemDM.synonym}</div>);
        }

        let antonym = '';
        if (this.dictionaryConfigDM !== null && this.dictionaryConfigDM.showAntonym && this.state.selectedItemDM !== null && this.state.selectedItemDM.antonym !== null) {
            antonym = (<div className='Antonym'>antonym: {this.state.selectedItemDM.antonym}</div>);
        }

        let sentences = '';
        if (this.dictionaryConfigDM !== null && this.dictionaryConfigDM.showExamples && this.state.selectedItemDM !== null && this.state.selectedItemDM.sentences.length > 0) {
            sentences = this.state.selectedItemDM.sentences.map((sentence, index) => {
                return (<div key={ index } className='SampleSentence'><span>&#x2015;</span> { parse(sentence) }</div>);
            });
        }

        let turkishMeaning = '';
        if (this.dictionaryConfigDM !== null && this.dictionaryConfigDM.showTurkishMeaning && this.state.selectedItemDM !== null && this.state.selectedItemDM.meaningTR !== null) {
            turkishMeaning = (<div className='TurkishMeaning'><span>&#x25A0;</span> {this.state.selectedItemDM.meaningTR}</div>);
        }

        let englishMeaning = '';

        if (this.dictionaryConfigDM !== null && this.dictionaryConfigDM.showEnglishMeaning && this.state.selectedItemDM !== null && this.state.selectedItemDM.meaningEN !== null) {
            englishMeaning = (<div className='EnglishMeaning'><span>&#x25A0;</span> {this.state.selectedItemDM.meaningEN}</div>);
        }


        let rightPane = (<div className='IteamDictionaryComponentRightPane'>
                            <div className='IteamDictionaryNothingFoundText'>Sorry, nothing found...</div>
                         </div>);

        if (this.state.displayedWords.length > 0) {
            rightPane = (<div className='IteamDictionaryComponentRightPane'>
                            <div className='IteamDictionaryComponentRightPaneL'>
                                <div className='IteamDictionaryHeader'>
                                    <div className='IteamDictionaryWord'>
                                        {this.state.selectedItemDM !== null ? this.state.selectedItemDM.text : 'None'} {type}
                                        <span>
                                            <button onClick={() => this.playAudioCallBack(this.state.selectedItemDM)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M168.23,171.76a3.58,3.58,0,0,1-2.53-6.1,93,93,0,0,0,0-131.32,3.57,3.57,0,0,1,5.05-5.05,100.09,100.09,0,0,1,0,141.42A3.54,3.54,0,0,1,168.23,171.76Z"/><path d="M148,151.56a3.58,3.58,0,0,1-2.53-6.1,64.27,64.27,0,0,0,0-90.92,3.57,3.57,0,1,1,5-5,71.41,71.41,0,0,1,0,101A3.54,3.54,0,0,1,148,151.56Z"/><path d="M127.81,131.35a3.58,3.58,0,0,1-2.52-6.1,35.71,35.71,0,0,0,0-50.5,3.57,3.57,0,1,1,5-5,42.85,42.85,0,0,1,0,60.6A3.56,3.56,0,0,1,127.81,131.35Z"/><path d="M112.36.39a3.59,3.59,0,0,0-3.72.29l-72.92,53v92.6l72.92,53a3.57,3.57,0,0,0,5.67-2.89V3.57A3.55,3.55,0,0,0,112.36.39Z"/><path d="M28.58,57.14h-25A3.57,3.57,0,0,0,0,60.71v78.58a3.57,3.57,0,0,0,3.57,3.57h25Z"/></svg>
                                            </button>
                                        </span>
                                    </div>
                                    {synonym}
                                    {antonym}
                                </div>
                                <div className='IteamDictionaryBody'>
                                    {turkishMeaning}
                                    {englishMeaning}
                                    {sentences}
                                </div>
                            </div>
                            <div className='IteamDictionaryComponentRightPaneR'>
                                    {this.state.selectedItemDM !== null &&  this.state.selectedItemDM.imageUrl !== null && <img style={{display: 'block', width: 'auto', height: 'auto', maxWidth: '300px', borderRadius: '15px', border: '1px solid #4D4E4E'}} 
                                                        src={`${this.dictionaryConfigDM.basePath}/${this.state.selectedItemDM.imageUrl}`} 
                                                        alt='current word' />}
                            </div>
                        </div>);
        }

        return (<div className='IteamDictionaryComponent'>
            <div className='IteamDictionaryComponentLeftPane'>
                <div className='UnitSelectBoxContainer'>
                    <select onChange={this.unitSelectBoxOnChangeCallBack}>
                        <option value=''>ALL UNITS</option>
                        {this.dictionaryConfigDM !== null && this.dictionaryConfigDM.units.map((unit, index) => {
                            return <option key={index} value={unit.unit_value}>{unit.unit_name}</option>;
                        })}
                    </select>
                </div>
                <div className='SearchBoxContainer'>
                    <input type='text' placeholder='Type word or phrase'
                            style={this.state.inputBGColorStyle} 
                            onKeyUp={this.searchInputOnKeyUpCallBack}
                            ref={this.inputBoxRef} />
                    <button onClick={this.clearSearchInputButtonOnClickCallBack}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M139.25,100,191.9,47.34A27.75,27.75,0,0,0,152.66,8.1L100,60.75,47.34,8.1A27.75,27.75,0,0,0,8.1,47.34L60.75,100,8.1,152.66A27.75,27.75,0,0,0,47.34,191.9L100,139.25l52.66,52.65a27.75,27.75,0,0,0,39.24-39.24Z"/></svg>
                    </button>
                </div>
                <div className='WordListContainer'>
                    <div className='WordList'>
                        {words.map((dictionaryWordDM, index) => {
                            let style = {};
                            if (this.state.selectedItemDM === dictionaryWordDM) {
                                style = {color: '#F05A26'};
                            }
                            return <div key={ index } className='dictionaryWordItem' style={style} onClick={() => this.itemClickHandler(dictionaryWordDM)}>{ dictionaryWordDM.text }</div>;
                        })}
                    </div>
                </div>
            </div>
            {rightPane}
        </div>);
    }
}

export default IteamDictionaryComponent;